import NonEnsuite from "@Icons/NonEnsuite";
import EnsuiteIcon from "@Icons/EnsuiteIcon";
import StudioIcon from "@Icons/StudioIcon";
import OneBIcon from "@Icons/OneBIcon";
import TwoBIcon from "@Icons/TwoBIcon";
import ThreeBIcon from "@Icons/ThreeBIcon";
import FourBIcon from "@Icons/FourBIcon";
import SixBIcon from "@Icons/SixBIcon";
import SevenBIcon from "@Icons/SevenBIcon";
import EightBIcon from "@Icons/EightBIcon";
import GreaterEightBIcon from "@Icons/GreaterEightBIcon";
import SharedRoomIcon from "@Icons/SharedRoomIcon";

const unitTypesDescription = (t: (key: string) => string) => ({
  all: { icon: "All", text: t("propertypage.components.roomtype.unittype.all") },
  twin_studio: {
    icon: <StudioIcon />,
    text: t("propertypage.components.roomtype.unittype.twinstudio"),
  },
  twin_ensuite: {
    icon: <EnsuiteIcon />,
    text: t("propertypage.components.roomtype.unittype.twinensuite"),
  },
  ensuite: {
    icon: <EnsuiteIcon />,
    text: t("propertypage.components.roomtype.ensuite"),
  },
  non_ensuite: {
    icon: <NonEnsuite />,
    text: t("propertypage.components.roomtype.unittype.nonensuite"),
  },
  studio: {
    icon: <StudioIcon />,
    text: t("propertypage.components.roomtype.unittype.studio"),
  },
  shared_room: {
    icon: <SharedRoomIcon />,
    text: t("propertypage.components.roomtype.unittype.sharedroom"),
  },
  private_room: {
    icon: <EnsuiteIcon />,
    text: t("propertypage.components.roomtype.unittype.privateroom"),
  },
  "1b": {
    icon: <OneBIcon />,
    text: t("propertypage.components.roomtype.unittype.1b"),
  },
  "2b": {
    icon: <TwoBIcon />,
    text: t("propertypage.components.roomtype.unittype.2b"),
  },
  "3b": {
    icon: <ThreeBIcon />,
    text: t("propertypage.components.roomtype.unittype.3b"),
  },
  "4b": {
    icon: <FourBIcon />,
    text: t("propertypage.components.roomtype.unittype.4b"),
  },
  "5b": {
    icon: <FourBIcon />,
    text: t("propertypage.components.roomtype.unittype.5b"),
  },
  "6b": {
    icon: <SixBIcon />,
    text: t("propertypage.components.roomtype.unittype.6b"),
  },
  "7b": {
    icon: <SevenBIcon />,
    text: t("propertypage.components.roomtype.unittype.7b"),
  },
  "8b": {
    icon: <EightBIcon />,
    text: t("propertypage.components.roomtype.unittype.8b"),
  },
  greater_8b: {
    icon: <GreaterEightBIcon />,
    text: t("propertypage.components.roomtype.unittype.greater8b"),
  },
});

export default unitTypesDescription;
